import React from "react";
import ReactModal from "react-modal";
import useViewerSignupReminderToggle from "src/hooks/useViewerSignupReminderToggle";
import NetworkDisconnectedAlertPanelOverlayCmp from "../NetworkDisconnectedAlertPanelOverlayCmp";
import WebcastPageFooterLineCmp from "../WebcastPageFooterLineCmp";
import {TaggedLogger} from "@nextlot/core/utilities";
import {WebcastStateEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {useTranslation} from "react-i18next";
import useWebcastConnect from "@nextlot/core/webcast/hooks/useWebcastConnect";
import BidderPageHeaderCmp from "./BidderPageHeaderCmp";
import BidderCatalogAndMyPurchasesCmp from "./BidderCatalogAndMyPurchasesCmp";
import BidderChatBoxCmp from "./BidderChatBoxCmp";
import BidderBiddingAreaLayoutRootCmp from "./BidderBiddingAreaLayoutRootCmp";
import BidderCurrentRoundLotsCmp from "./BidderCurrentRoundLotsCmp";
import BidderMediaStreamingRootCmp from "./BidderMediaStreamingRootCmp";






const _logger = TaggedLogger.get('BidderRootCmp');

export default function BidderRootCmp() {
    // _logger.debug('.render()', props);

    const webcastStatusState = useWebcastConnect();
    const { t, i18n } = useTranslation();

    const [isModalOpen, modal_onRequestClose] = useViewerSignupReminderToggle();

    return (
        <>
            <NetworkDisconnectedAlertPanelOverlayCmp />

            {

                (webcastStatusState === WebcastStateEnum.WEBCAST_STATE__CLOSED)
                    ? <div className="w-100 h-100 d-flex justify-content-center align-items-center"><h3>{t('webcastFinished')}</h3></div>
                    : (webcastStatusState > WebcastStateEnum.WEBCAST_STATE__LOADING)
                        ? <LoadedAppStateViewCmp />
                        : <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                            <h3>Loading, please wait ...</h3>
                          </div>


            }

            <WebcastPageFooterLineCmp screenName={'Bidder'} />

            <ViewerSignupReminderModal isModalOpen={isModalOpen} modal_onRequestClose={modal_onRequestClose} ctaLabel={t('biddingArea.registerLogin')}/>

        </>
    )
}



function LoadedAppStateViewCmp(props) {

    const { t, i18n } = useTranslation();

    return (
        <React.Fragment>

            <BidderPageHeaderCmp/>

            <div className="bidder-page-main-container">

                <div className="bidder-column-catalog-container">
                    {/* @ts-ignore */}
                    <BidderCatalogAndMyPurchasesCmp/>

                    <div className="vertical-spacer"/>

                    {/* @ts-ignore */}
                    <BidderChatBoxCmp/>
                </div>

                <div className="bidder-column-bidding-container">
                    <BidderMediaStreamingRootCmp />
                    <BidderBiddingAreaLayoutRootCmp />
                </div>

                <div className="bidder-column-round-container">
                    <BidderCurrentRoundLotsCmp />
                </div>

            </div>
        </React.Fragment>
    )
}

function ViewerSignupReminderModal(props: {isModalOpen: boolean, modal_onRequestClose: React.MouseEventHandler<HTMLButtonElement>, ctaLabel: string}) {

    const {isModalOpen, modal_onRequestClose, ctaLabel} = props;

    return (
        <ReactModal
            isOpen={isModalOpen}
            onRequestClose={modal_onRequestClose}
            contentLabel="Lot details"
            portalClassName={'rmodal__portal'}
            overlayClassName={{ base: 'rmodal__overlay', afterOpen: 'rmodal__overlay--after-open', beforeClose: '' }}
            className={'rmodal__dialog'}
            bodyOpenClassName={'rmodal__html-body--open'}
            style={{overlay: {zIndex: '100'}}}
        >
            <div className='lot-details__container'>
              <div className='lot-details__body p-4'>
                  <button onClick={modal_onRequestClose} type="button" className="float-end btn-close"></button>
                  <div className="row h3 pt-5 justify-content-center">
                      <div className="col-sm-12 col-md-6">
                          <h1 className="mb-4">Enhance Your Auction Experience</h1>
                          <p className="fw-light mb-5">
                              <ul>
                                  <li className="mb-1">Participate in Real-Time Bidding</li>
                                  <li className="mb-1">Track Your Winning Purchases</li>
                                  <li className="mb-1">Access Auction House Privileges</li>
                                  <li className="mb-1">Watch the Webcast Stream Uninterrupted</li>
                                  <li><a href="https://knowledgebase.nextlot.com/knowledge/how-to-bid-in-a-webcast-auction" target="_blank">Guide For Bidding in a Live Webcast Auction</a></li>
                              </ul>
                          </p>
                          <h3>Login or create your account to get started</h3>
                          <div className="bidder-bidding-area-wrapper">
                              <div>
                                  <a className="w-auto p-3 h4 btn btn-lg btn-bid" href={`${location.origin}/bidder/start`} rel="noopener noreferrer">
                                      {ctaLabel}
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>


            <div className='lot-details__footer'>
            </div>
        </ReactModal>
    )
}
